import { usePosterContext } from "../../../../context/poster-context";
import {
  MainInfoColorInput,
  MainInfoContentItem,
  MainInfoContentItemInput,
  MainInfoContentWrapper,
  MainInfoHeader,
  MainInfoHeaderItem,
  MainInfoWrapper,
} from "./styles/main-info.style";
import { Checkbox } from "../../../../../../styles/page";

// 3자리 색상 코드를 6자리로 변환 (#FFF -> #FFFFFF)
const normalizeColor = (color: string | undefined): string => {
  const trimmed = color?.trim().toUpperCase() || "#FFFFFF";
  if (trimmed.length === 4 && trimmed.startsWith("#")) {
    // #FFF 형식을 #FFFFFF로 변환
    return `#${trimmed[1]}${trimmed[1]}${trimmed[2]}${trimmed[2]}${trimmed[3]}${trimmed[3]}`;
  }
  return trimmed;
};

const MainInfo = () => {
  const {
    title,
    setTitle,
    subTitle,
    setSubTitle,
    startDate,
    setStartDate,
    pubName,
    setPubName,
  } = usePosterContext();

  const items = [
    {
      key: "title",
      label: "타이틀",
      data: title,
      setData: setTitle,
    },
    {
      key: "subTitle",
      label: "서브타이틀",
      data: subTitle,
      setData: setSubTitle,
    },
    {
      key: "startDate",
      label: "시작 일시",
      data: startDate,
      setData: setStartDate,
    },
    {
      key: "pubName",
      label: "매장명",
      data: pubName,
      setData: setPubName,
    },
  ];

  return (
    <MainInfoWrapper>
      <MainInfoHeader>
        <MainInfoHeaderItem flex={1}>포함여부</MainInfoHeaderItem>
        <MainInfoHeaderItem flex={2}>항목</MainInfoHeaderItem>
        <MainInfoHeaderItem flex={4}>내용 </MainInfoHeaderItem>
        <MainInfoHeaderItem flex={1}>색상</MainInfoHeaderItem>
      </MainInfoHeader>
      {items.map((item) => (
        <MainInfoContentWrapper key={item.key}>
          <MainInfoContentItem flex={1}>
            <Checkbox
              checked={item.data.isShow}
              onChange={() => {
                item.setData({
                  ...item.data,
                  isShow: !item.data.isShow,
                });
              }}
            />
          </MainInfoContentItem>
          <MainInfoContentItem flex={2}>
            <div className="label">{item.label}</div>
          </MainInfoContentItem>
          <MainInfoContentItem flex={4}>
            <MainInfoContentItemInput
              disabled={!item.data.isShow}
              value={item.data.value}
              onChange={(e) => {
                item.setData({
                  ...item.data,
                  value: e.target.value,
                });
              }}
            />
          </MainInfoContentItem>
          <MainInfoContentItem flex={1}>
            <MainInfoColorInput
              type="color"
              value={normalizeColor(item.data.color)}
              onChange={(e) => {
                item.setData({
                  ...item.data,
                  color: e.target.value.toUpperCase(),
                });
              }}
            />
          </MainInfoContentItem>
        </MainInfoContentWrapper>
      ))}
    </MainInfoWrapper>
  );
};

export default MainInfo;
